/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faArrowLeft,
  faSearch,
  faSync,
  faEdit,
  faTimes,
  faSave,
} from '@fortawesome/free-solid-svg-icons';
import { API_URL } from '../../config';
import { showToast } from '../../components/toast';
import '../../components/skeletonRow.css';
import './AdsReport.css';

const AdsCampaignUpdate = () => {
  const navigate = useNavigate();

  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Edit Modal State
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [newCampaignName, setNewCampaignName] = useState('');
  const [saving, setSaving] = useState(false);

  // Fetch campaign mapping list
  const fetchCampaigns = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const res = await axios.get(`${API_URL}report-ads/campaign-mapping-list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.success) {
        setCampaigns(res.data.data || []);
      }
    } catch (err) {
      console.error('Failed to load campaigns list', err);
      showToast.error('Failed to load campaign list.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCampaigns();
    window.scrollTo(0, 0);
    const contentEl = document.getElementById('content');
    if (contentEl) contentEl.scrollTop = 0;
    const pageContainer = document.getElementById('page-container');
    if (pageContainer) pageContainer.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [fetchCampaigns]);

  // Open Edit Modal
  const handleOpenEdit = (item) => {
    setSelectedCampaign(item);
    setNewCampaignName(item.campaign_name || '');
    setEditModalOpen(true);
  };

  // Close Edit Modal
  const handleCloseEdit = () => {
    if (saving) return;
    setEditModalOpen(false);
    setSelectedCampaign(null);
    setNewCampaignName('');
  };

  // Save Campaign Name Update
  const handleSaveCampaignName = async (e) => {
    e?.preventDefault();
    if (!selectedCampaign) return;

    try {
      setSaving(true);
      const token = localStorage.getItem('authToken');
      const payload = {
        campaign: selectedCampaign.campaign,
        campaign_name: newCampaignName.trim(),
      };

      const res = await axios.post(
        `${API_URL}report-ads/update-campaign-name`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.success) {
        showToast.success(res.data.message || 'Campaign name updated successfully!');
        handleCloseEdit();
        fetchCampaigns();
      } else {
        showToast.error(res.data?.message || 'Failed to update campaign name.');
      }
    } catch (err) {
      console.error('Update campaign name error', err);
      showToast.error(err.response?.data?.message || 'Failed to update campaign name.');
    } finally {
      setSaving(false);
    }
  };

  // Filter list by search term
  const filteredList = campaigns.filter((item) => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase();
    return (
      (item.campaign && item.campaign.toLowerCase().includes(term)) ||
      (item.campaign_name && item.campaign_name.toLowerCase().includes(term))
    );
  });

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content">
        {/* Top Header Row 1: Breadcrumbs on Left and Back Button on Right */}
        <div className="row pb-2 align-items-center">
          <div className="col-md-6">
            <ul className="breadcrumb" style={{ margin: 0, padding: 0, background: 'transparent' }}>
              <li className="breadcrumb-item">
                <a href="/dashboard" style={{ textDecoration: 'none' }}>
                  <FontAwesomeIcon icon={faHome} /> Home
                </a>
              </li>
              <li className="breadcrumb-item">Reports</li>
              <li className="breadcrumb-item">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/Report/adsReport');
                  }}
                  style={{ textDecoration: 'none', color: '#007bff' }}
                >
                  Ads Report
                </a>
              </li>
              <li className="breadcrumb-item active">Campaign Update</li>
            </ul>
          </div>

          <div className="col-md-6 d-flex justify-content-end align-items-center gap-2">
            <button
              type="button"
              className="btn btn-default btn-sm"
              onClick={() => navigate('/Report/adsReport')}
              style={{
                height: '31px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontWeight: '600',
              }}
              title="Back to Ads Report"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Back to Ads Report</span>
            </button>
          </div>
        </div>


        {/* Main Content: Table Panel */}
        <div className="panel panel-default with-rounded-corner with-shadow" style={{ marginBottom: '20px' }}>
          {/* Panel Heading */}
          <div
            className="panel-heading d-flex justify-content-between align-items-center"
            style={{
              padding: '10px 15px',
              borderBottom: '1px solid #e2e8f0',
            }}
          >
            <h4 className="panel-title" style={{ fontSize: '14px', fontWeight: '600', margin: 0 }}>
              Campaign List ({filteredList.length})
            </h4>

            <div className="d-flex align-items-center gap-2">
              {/* Search Filter */}
              <div style={{ position: 'relative', width: '260px' }}>
                <input
                  type="text"
                  className="form-control input-sm"
                  placeholder="Search Sheet or CRM Campaign..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingRight: '28px', height: '30px', fontSize: '12px' }}
                />
                {searchTerm ? (
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => setSearchTerm('')}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#94a3b8',
                      fontSize: '12px',
                    }}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faSearch}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#94a3b8',
                      fontSize: '12px',
                      pointerEvents: 'none',
                    }}
                  />
                )}
              </div>

              {/* Refresh Button */}
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={fetchCampaigns}
                disabled={loading}
                style={{ height: '30px', fontSize: '12px' }}
                title="Refresh List"
              >
                <FontAwesomeIcon icon={faSync} spin={loading} className={loading ? '' : 'me-1'} />
                {!loading && <span>Refresh</span>}
              </button>
            </div>
          </div>

          {/* Table Container */}
          <div className="panel-body p-0">
            <div className="table-responsive">
              <table className="table table-condensed table-hover bg-white sticky-table mb-0" style={{ fontSize: '13px' }}>
                <thead>
                  <tr>
                    <th style={{ width: '50px', textAlign: 'center' }}>#</th>
                    <th style={{ minWidth: '220px' }}>Sheet Campaign</th>
                    <th style={{ minWidth: '220px' }}>CRM Campaign Name</th>
                    <th style={{ width: '130px', textAlign: 'center' }}>Ad Records</th>
                    <th style={{ width: '70px', textAlign: 'center' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 6 }).map((_, idx) => (
                      <tr key={`skeleton-${idx}`}>
                        <td className="text-center">
                          <div className="skeleton-text" style={{ width: '20px', margin: '0 auto', height: '14px' }}></div>
                        </td>
                        <td>
                          <div className="skeleton-text" style={{ width: '65%', height: '14px' }}></div>
                        </td>
                        <td>
                          <div className="skeleton-text" style={{ width: '55%', height: '14px' }}></div>
                        </td>
                        <td className="text-center">
                          <div className="skeleton-text" style={{ width: '45px', margin: '0 auto', height: '14px' }}></div>
                        </td>
                        <td className="text-center">
                          <div className="skeleton-text" style={{ width: '24px', margin: '0 auto', height: '14px' }}></div>
                        </td>
                      </tr>
                    ))
                  ) : filteredList.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center text-muted" style={{ padding: '30px 15px' }}>
                        No campaigns found.
                      </td>
                    </tr>
                  ) : (
                    filteredList.map((item, index) => (
                      <tr key={`camp-${item.campaign}-${index}`}>
                        <td className="text-center text-muted" style={{ verticalAlign: 'middle' }}>
                          {index + 1}
                        </td>

                        {/* Sheet Campaign */}
                        <td style={{ verticalAlign: 'middle', color: '#334155', fontWeight: 500 }}>
                          {item.campaign || '-'}
                        </td>

                        {/* CRM Campaign Name */}
                        <td style={{ verticalAlign: 'middle', fontWeight: 600, color: '#007bff' }}>
                          {item.campaign_name || (
                            <span className="text-muted fst-italic" style={{ fontWeight: 400, color: '#94a3b8' }}>
                              (Unmapped)
                            </span>
                          )}
                        </td>

                        {/* Ad Records Count */}
                        <td className="text-center" style={{ verticalAlign: 'middle', fontWeight: 500 }}>
                          {Number(item.records_count || 0).toLocaleString('en-IN')}
                        </td>

                        {/* Action: Yellow Icon Edit Button */}
                        <td className="text-center" style={{ verticalAlign: 'middle' }}>
                          <button
                            type="button"
                            className="btn btn-warning btn-xs"
                            style={{
                              width: '26px',
                              height: '24px',
                              padding: 0,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '4px',
                            }}
                            onClick={() => handleOpenEdit(item)}
                            title="Edit CRM Campaign Name"
                          >
                            <FontAwesomeIcon icon={faEdit} style={{ fontSize: '11px' }} />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Edit CRM Campaign Name Modal */}
        {editModalOpen && (
          <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '520px' }}>
              <div className="modal-content with-rounded-corner with-shadow" style={{ borderRadius: '8px' }}>
                <div
                  className="modal-header d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: '#f8fafc',
                    borderBottom: '1px solid #e2e8f0',
                    padding: '12px 20px',
                  }}
                >
                  <h5 className="modal-title" style={{ fontSize: '15px', fontWeight: '700', color: '#1e293b' }}>
                    <FontAwesomeIcon icon={faEdit} className="text-warning me-2" />
                    Edit CRM Campaign Name
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseEdit}
                    disabled={saving}
                    style={{ border: 'none', background: 'transparent', fontSize: '16px', cursor: 'pointer' }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>

                <form onSubmit={handleSaveCampaignName}>
                  <div className="modal-body" style={{ padding: '20px' }}>
                    {/* Sheet Campaign (Read Only) */}
                    <div className="mb-3">
                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#64748b', marginBottom: '4px' }}>
                        Sheet Campaign (From Google Sheet)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedCampaign?.campaign || ''}
                        readOnly
                        disabled
                        style={{
                          backgroundColor: '#f1f5f9',
                          borderColor: '#cbd5e1',
                          fontSize: '13px',
                          fontWeight: '500',
                          color: '#475569',
                        }}
                      />
                      <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '3px' }}>
                        Matches {Number(selectedCampaign?.records_count || 0).toLocaleString('en-IN')} records in Ads Report
                      </div>
                    </div>

                    {/* CRM Campaign Name (Editable) */}
                    <div className="mb-3">
                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#1e293b', marginBottom: '4px' }}>
                        CRM Campaign Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter unified CRM campaign name..."
                        value={newCampaignName}
                        onChange={(e) => setNewCampaignName(e.target.value)}
                        required
                        autoFocus
                        style={{ fontSize: '13px', height: '36px', borderColor: '#93c5fd' }}
                      />
                      <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
                        Saving will update <code>campaign_name</code> for <strong>ALL</strong> {selectedCampaign?.records_count || 0} records matching this Sheet Campaign.
                      </div>
                    </div>
                  </div>

                  <div
                    className="modal-footer d-flex justify-content-end gap-2"
                    style={{
                      backgroundColor: '#f8fafc',
                      borderTop: '1px solid #e2e8f0',
                      padding: '12px 20px',
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-default btn-sm"
                      onClick={handleCloseEdit}
                      disabled={saving}
                      style={{ minWidth: '80px', height: '32px' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm"
                      disabled={saving || !newCampaignName.trim()}
                      style={{ minWidth: '90px', height: '32px' }}
                    >
                      {saving ? (
                        <>
                          <FontAwesomeIcon icon={faSync} spin className="me-1" /> Saving...
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faSave} className="me-1" /> Save
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdsCampaignUpdate;
